var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-coemplete", {
    attrs: { placeholder: "Pesquisar", options: _vm.options },
    on: {
      "vue-coemplete:focus": _vm.setFocus,
      "vue-coemplete:select": function(item) {
        return (_vm.searchValue = item["key"])
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function(ref) {
          var onSearch = ref.onSearch
          var keyboardEvents = ref.keyboardEvents
          return _c("input", {
            ref: "inputSlot",
            staticClass: "input",
            domProps: { value: _vm.searchValue },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return keyboardEvents.up($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return keyboardEvents.down($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return keyboardEvents.select($event)
                }
              ],
              input: function(event) {
                return _vm.onInput(event.target.value, onSearch)
              }
            }
          })
        }
      },
      {
        key: "after",
        fn: function(ref) {
          var item = ref.item
          return _c("span", {}, [_vm._v(" - " + _vm._s(item.area))])
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }